import { ALL_LAYOUTS } from 'constants/SceneLayouts';

export const isValidLayout = id => {
  return !!ALL_LAYOUTS.find(layout => layout.id === id);
};
